import { selectUser } from '@qwealth/qdata';

import { useFeatureFlag } from 'hooks/useFeatureFlag';
import { useAppSelector } from 'data/store';
import { FeatureFlag } from 'data/models/featureFlag';

export type ProtectionType = 'restrictive' | 'permissive';

export interface UseAccessProtectorProps {
  featureFlag?: FeatureFlag;
  rolesAllowed?: number[];
  type?: ProtectionType;
}

export const useAccessProtector = ({ featureFlag, rolesAllowed, type = 'restrictive' }: UseAccessProtectorProps): boolean => {
  const user = useAppSelector(selectUser);
  const hasRoleAccess = !rolesAllowed || rolesAllowed.includes(user.roleID);
  const hasFeatureFlagAccess = useFeatureFlag(featureFlag);
  if (!featureFlag && !rolesAllowed) {
    return false;
  }
  if (type === 'restrictive') {
    return hasFeatureFlagAccess && hasRoleAccess;
  } else if (type === 'permissive') {
    return hasFeatureFlagAccess || hasRoleAccess;
  }
  return false;
};
